/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestSolvV2ConvertibleManualPriceOracle extends Contract<ITestSolvV2ConvertibleManualPriceOracle> {
  _setPrice: Send<(_underlying: AddressLike, _maturity: BigNumberish, _price: BigNumberish) => void, ITestSolvV2ConvertibleManualPriceOracle>
  '_setPrice(address,uint64,int256)': Send<(_underlying: AddressLike, _maturity: BigNumberish, _price: BigNumberish) => void, ITestSolvV2ConvertibleManualPriceOracle>
}

let ITestSolvV2ConvertibleManualPriceOracleBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestSolvV2ConvertibleManualPriceOracleBytecode = '0x';
}

// prettier-ignore
export const ITestSolvV2ConvertibleManualPriceOracle = contract<ITestSolvV2ConvertibleManualPriceOracle>(ITestSolvV2ConvertibleManualPriceOracleBytecode)`
  function _setPrice(address _underlying, uint64 _maturity, int256 _price)
`;